// extracted by mini-css-extract-plugin
module.exports = {"stepperIcon":"styles_stepperIcon__1P0aI","activeStepperIcon":"styles_activeStepperIcon__32Snj","completedStepperIcon":"styles_completedStepperIcon__1VK5t"};